import script from "./ModuleEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleEditor.vue?vue&type=script&setup=true&lang=js"

import "./ModuleEditor.vue?vue&type=style&index=0&id=60f55cd6&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f55cd6"]])

export default __exports__